import { Injectable } from '@angular/core';

export const SSY_CONSTRAINTS = {
  yearlyDeposit: { min: 250, max: 150_000, step: 250 },
  rate:          { min: 1,   max: 12,      step: 0.1 },
  girlAge:       { min: 0,   max: 9,       step: 1   }
} as const;

export const SSY_DEPOSIT_YEARS  = 15;
export const SSY_MATURITY_YEARS = 21;

export interface SsyYearRow {
  year: number;
  openingBalance: number;
  deposit: number;
  interest: number;
  closingBalance: number;
}

export interface SsyResult {
  rows: SsyYearRow[];
  totalInvested: number;
  totalInterest: number;
  maturityValue: number;
}

@Injectable({ providedIn: 'root' })
export class SsyCalculatorService {

  /** Deposits allowed for the first 15 years; balance keeps earning interest until maturity at 21 years. */
  calculate(yearlyDeposit: number, annualRate: number): SsyResult {
    const rate = annualRate / 100;
    const rows: SsyYearRow[] = [];
    let balance = 0;
    let totalInvested = 0;

    for (let year = 1; year <= SSY_MATURITY_YEARS; year++) {
      const deposit = year <= SSY_DEPOSIT_YEARS ? yearlyDeposit : 0;
      const opening = balance;
      const interest = (opening + deposit) * rate;
      const closing = opening + deposit + interest;
      rows.push({ year, openingBalance: opening, deposit, interest, closingBalance: closing });
      balance = closing;
      totalInvested += deposit;
    }

    return {
      rows,
      totalInvested,
      totalInterest: balance - totalInvested,
      maturityValue: balance
    };
  }
}
